
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from '@/components/ui/form';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { CreateTechniqueFormValues } from './FormSchema';

interface TechniqueTypeFieldsProps {
  form: UseFormReturn<CreateTechniqueFormValues>;
}

export const TechniqueTypeFields: React.FC<TechniqueTypeFieldsProps> = ({ form }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {/* Technique Position */}
      <FormField
        control={form.control}
        name="techniquePosition"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Position Type*</FormLabel>
            <Select 
              onValueChange={field.onChange} 
              defaultValue={field.value}
            >
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Select position type" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="standing">Standing</SelectItem>
                <SelectItem value="top">Top</SelectItem>
                <SelectItem value="bottom">Bottom</SelectItem>
                <SelectItem value="transitional">Transitional</SelectItem>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />

      {/* Technique Type */}
      <FormField
        control={form.control}
        name="techniqueType"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Technique Type*</FormLabel>
            <Select 
              onValueChange={field.onChange} 
              defaultValue={field.value}
            >
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Select technique type" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="choke">Choke</SelectItem>
                <SelectItem value="joint_lock">Joint Lock</SelectItem>
                <SelectItem value="sweep">Sweep</SelectItem>
                <SelectItem value="takedown">Takedown</SelectItem>
                <SelectItem value="control">Control</SelectItem>
                <SelectItem value="escape">Escape</SelectItem>
                <SelectItem value="defensive">Defensive</SelectItem>
                <SelectItem value="guard_passing">Guard Passing</SelectItem>
                <SelectItem value="other">Other</SelectItem>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />

      {/* Difficulty */}
      <FormField
        control={form.control}
        name="difficulty"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Difficulty Level*</FormLabel>
            <Select 
              onValueChange={field.onChange} 
              defaultValue={field.value}
            >
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Select difficulty" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="beginner">Beginner</SelectItem>
                <SelectItem value="intermediate">Intermediate</SelectItem>
                <SelectItem value="advanced">Advanced</SelectItem>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
